import { Injectable } from '@angular/core';
import { BaseLocalStorageService } from '../services/base-local-storage.service';
import { LocalStorageConstants } from '../constants/local-storage-constants';
import { CountriesConstants } from '../constants/countries-constant';
import { CountryModel } from '../models/country-model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(
    private _localStorageService: BaseLocalStorageService
  ) {}

  setCountryId(countryId: string): void {
    this._localStorageService.setString(LocalStorageConstants.Country, btoa(countryId));
  }

  getCurrentCountryId() : string {
    let countryB64 = this._localStorageService.getString(LocalStorageConstants.Country);
    return countryB64 ? atob(countryB64) : "";
  }

  getCountryById(countryId: string): CountryModel|undefined {
    return CountriesConstants.find( country => country.id == countryId);
  }
}
